import Grid from '@material-ui/core/Grid'
import Select from 'Components/Select'
import Title from 'Components/Title'
import Upload from 'Components/Upload'
import React from 'react'


export default class ComboMultiDocument extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} style={{padding: '5px 0'}} title={this.props.title} buttons={(this.props.comboMultipleOption(this.props.options)).length > 0 && !this.props.disabled &&
      <button type="button" onClick={this.props.onClickAddComboMultiEntier} className="text-success ei-commun_ajouter"
              style={{display: 'inline-block', marginLeft: 5}}/>}>
        {
          (this.props.data !== undefined ? this.props.data : []).map((data, index) => (
            <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              { !this.props.disabled && <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => this.props.onClickRemoveComboMultiEntier(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={this.props.disabled || false}/>
              </Grid>}
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Select style={this.props.style}
                  disabled={this.props.disabled || false}
                  options={this.props.comboMultipleOption(this.props.options, data.id)}
                  onChange={this.props.onChangeComboMultiEntier}
                  name={index}
                  value={data.id}/>
              </Grid>
              {this.props.client_id && (!this.props.disabled || (this.props.disabled && data.valeur_entier)) && <Grid item style={{margin: 0, padding: 0}}>
                <Upload disabled={this.props.disabled || false} media_id={data.valeur_entier} link={data.lien} client_id={this.props.client_id} onChange={(r) => this.props.onChangeInputComboMultiUpload(r.id, index, r.lien)}/>
              </Grid> }
            </Grid>
          ))
        }
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboMulti/ComboMultipleDocument.js